<template>
  <!-- eslint-disable vue/no-mutating-props -->
  <div class="tb-form-group">
    <label class="tb-label layer-name">{{element.name}}</label>

    <div class="tb-form-group">
      <label class="tb-label">Display format</label>

      <select
        class="tb-select"
        v-model.lazy="element.format"
        data-entity="producer-editor-selectFormat"
        data-test="graphics-editor-date-format"
        @change="$emit('value', { value: $event.target.value, field: 'format'})"
      >
        <option
          v-for="format in formats"
          :key="format.format"
          :value="format.format"
        >
          {{format.display}}
        </option>
      </select>
    </div>

    <div class="tb-form-group">
      <div class="tb-checkbox">
        <input
          type="checkbox"
          id="customFormat"
          v-model="element.customFormat"
          data-entity="producer-editor-toggleCustomFormat"
          data-test="graphics-editor-date-customFormat"
          @change="$emit('value', { value: $event.target.checked, field: 'customFormat'} )"
        />

        <label class="checkbox" for="customFormat">Custom format</label>
      </div>
    </div>

    <div v-if="element.customFormat" class="tb-form-group">
      <input
        type="text"
        class="tb-input"
        name="format"
        :class="{'is-invalid': formatError }"
        v-model="format"
        data-entity="producer-editor-formatDate"
        data-test="graphics-editor-date-customFormat"
        @change="formatDate"
      />

      <span class="help-text text-xxs text-danger" v-if="formatError" data-test="graphics-editor-date-error">{{formatError}}</span><br>
      <span class="text-xxs"><a href="https://date-fns.org/v2.15.0/docs/format" target="_blank">Formatting documention</a></span>
    </div>

    <div class="tb-form-group">
      <div class="tb-checkbox">
        <input
          type="checkbox"
          id="customTimeZone"
          v-model="element.customTimeZone"
          data-entity="producer-editor-customTimeZone"
          data-test="graphics-editor-date-customTimeZone"
          @change="$emit('value', { value: $event.target.checked, field: 'customTimeZone'})"
        />

        <label class="checkbox" for="customTimeZone">Custom time zone</label>
      </div>
    </div>

    <div v-if="element.customTimeZone" class="tb-form-group">
      <select
        class="tb-select"
        data-entity="producer-editor-selectTimezone"
        data-test="graphics-editor-date-timezone"
        @change="setDaylightSavings"
      >
        <option
          v-for="timezone in timezones"
          :key="timezone"
          :selected="timezone.name == element.customTimeZoneName"
          :value="timezone.value"
          :data-name="timezone.name"
          :data-daylight-savings="timezone.useDaylightTime"
        >
          {{timezone.name}}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
import { format as dateFormat } from 'date-fns';
import timezones from './timezones';

export default {
  props: ['element'],
  data() {
    return {
      timezones,
      formatError: null,
      format: this.element.customFormatStyle,
      formats: [
        { format: 'EEEE MMMM do, yyyy', display: dateFormat(new Date(), 'EEEE MMMM do, yyyy') },
        { format: 'h:mm', display: dateFormat(new Date(), 'h:mm') },
        { format: 'h:mm aaaa', display: dateFormat(new Date(), 'h:mm aaaa') },
        { format: 'h:mm a', display: dateFormat(new Date(), 'h:mm a') },
        { format: 'h:mm a OOOO', display: dateFormat(new Date(), 'h:mm a OOOO') },
        { format: 'MMMM d', display: dateFormat(new Date(), 'MMMM d') },
        { format: 'MMM. d, yyyy', display: dateFormat(new Date(), 'MMM. d, yyyy') },
        { format: 'M/d/yy', display: dateFormat(new Date(), 'M/d/yy') },
        { format: 'M/d/yyyy', display: dateFormat(new Date(), 'M/d/yyyy') },
        { format: 'M/d', display: dateFormat(new Date(), 'M/d') },
        { format: 'M.d.yyyy', display: dateFormat(new Date(), 'M.d.yyyy') },
      ],
    };
  },
  methods: {
    formatDate($event) {
      const format = $event.target.value;

      if (!format.length) {
        this.formatError = 'Must have at least one formatting character';
        return;
      }

      try {
        dateFormat(new Date(), format);
      } catch (error) {
        this.formatError = 'Invalid date formatting';
        return;
      }

      this.formatError = null;
      this.$set(this.element, 'customFormatStyle', format);
      this.$emit('value', { value: format, field: 'customFormatStyle' });
    },
    getDate(format) {
      return dateFormat(new Date(), format);
    },
    setDaylightSavings($event) {
      this.$nextTick(() => {
        const option = $($event.target).find(':selected');
        const offset = $event.target.value;
        const daylightSavings = option.data('daylight-savings');
        const name = option.data('name');

        this.$set(this.element, 'customTimeZoneOffset', offset);
        this.$set(this.element, 'customTimeZoneName', name);
        this.$set(this.element, 'customTimeZoneHasDaylightSavings', daylightSavings);

        this.$emit('value', { value: offset, field: 'customTimeZoneOffset' });
        this.$emit('value', { value: name, field: 'customTimeZoneName' });
        this.$emit('value', { value: daylightSavings, field: 'customTimeZoneHasDaylightSavings' });
      });
    },
  },
};
</script>
